define(function (require) {
    //require('jszip');
    var $ = require('jquery');
    var _ = require('underscore');
    var moment = require('moment');
    require('moment-ru');
    require('moment-timezone');
    moment.locale('ru');

    var Backbone = require('backbone');
    var Marionette = require('marionette');
    var Routes = require('./routes');
    var Desktop = require('controllers/desktop');
    var Handlebars = require('handlebars');
    var I18n = require('i18n!nls/main');

    var TopNotice = require('utils/top-notice');
    var Message = require('utils/message');
    var Alert = require('utils/alert');
    var MttVerify = require('utils/mtt_verify');
    var Listener = require('utils/listener');
    var DetectMobile = require('utils/detect-mobile');
    var DetectBrowser = require('utils/detect-browser');
    var Storage = require('utils/storage');

    var UserSettings = require('models/user-settings');
    var SiteSettings = require('models/site_settings');
    var Account = require('models/account');
    var Timezone = require('models/timezone');
    var SessionData = require('models/session_data');
    var ModalsFactory   = require('modals/factory');
    var WebsocketConnectionPropertiesModel = require('modules/websocket/connection_properties');

    var Project = require('models/site');
    var Projects = require('collections/sites');
    var Traffic = require('collections/sites_traffic');
    var UserAccess = require('models/user-access');
    var User = require('models/user');
    var Tariff = require('models/tariff');
    //var SidebarView = require('views/sidebar');

    var MaskOptions = require('system/libs/inputmask_options');
    var FilterApi = require('system/libs/filter');
    var SideCard = require('modules/ui/sideCard/index');

    var ConnectionFactory = require('modules/websocket/factory');
    var MyIntercom = require('modules/intercom/intercom');
    var SMSSendService = require('./services/smsSend.service');
    var EmailSendService = require('./services/emailSend.service');
    var PhoneCallService = require('./services/phoneCall.service');

    // Sentry отключен
    /*
    import('@sentry/browser').then(Sentry => {
        if (process.env.SENTRY_DSN) {
            Sentry.init({
                dsn: process.env.SENTRY_DSN,
                release: process.env.RELEASE,
                environment: process.env.APP_ENV,
                beforeSend(event) {
                  const project = app.currentProjectId;
                  if (project) {
                    if (!event.tags) event.tags = {};
                    event.tags.project = project;
                  }

                  const account = event.tags.account = app.AUTH_ID;
                  if (account) {
                    if (!event.tags) event.tags = {};
                    event.tags.account = account;
                  }

                  const userId = app.Models.User.get('id');
                  if (userId) {
                    const userType = app.Models.User.get('profile_type');
                    if (!event.user) event.user = {};
                    event.user.id = userType + ':' + userId;
                  }

                  return event;
                },
            });
        }
    })
    */

  Handlebars.registerHelper('ifIn', function(elem, list, options) {
    if(list.indexOf(elem) > -1) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  require('jquery.select2');
    require('jquery.cookie');
    require('bootstrap.dropdown');
    require('bootstrap.tooltip');
    require('bootstrap.tab');
    require('bootstrap.collapse');
    require('lptSetter');
    require('arctic.modal');
    require('./logo');
    require('system/common');
    require('system/helpers');
    require('system/rivets-formatters');
    require('system/rivets-binders');
    require('utils/ajax-redeclare');
    var rivets = require('rivets');
    require('backbone.rivets');
    require('jquery.scrollbar');

    var AppConfig = require('config/application');

    $.cookie.defaults = {
        expires: 365
    };

    var Modal = Marionette.Object.extend({
        initialize: function (options) {
            this.options = options || {};
            this.stack = {};
        },

        show: function(view, id) {
            var $el = $('<div class="modal_' + view.cid + '"></div>');
            $(this.options.container).append($el);
            view.setElement($el);
            view.render();

            if (id) {
                this.hide(id);
                this.stack[id] = view;
                this.listenToOnce(view, 'destroy', function() {
                    delete this.stack[id]
                })
            }
        },

        hide: function(id) {
            this.stack[id] && this.stack[id].hide();
        }
    });

    var app = new Marionette.Application({
        regions: {
            regionHeader: '#b-header',
            regionContent: '#b-content',
            regionSidebar: '#sidebar-content',
            regionRightSidebar: '#right-sidebar',
            regionLeftSidebar: '#left-sidebar',
            regionPopover: '#b-popover',
            regionTopNotice: '#b-top-notice',
            regionPageSave: '#b-page-save',
            regionSideCard: '#js-sidecard-region'
        },
        services: {
            smsSend: SMSSendService,
            emailSend: EmailSendService,
            phoneCall: PhoneCallService,
        },
        global_refresh_menu: false,
        Colors: {
            'F7F0C5': {
                background: 'F7F0C5',
                color: 'c1aa1b'
            },
            'D2E4EB': {
                backgroun: 'D2E4EB',
                color: '448199'
            },
            'FFD5C2': {
                background: 'FFD5C2',
                color: 'e14600'
            },
            'DDDDDD': {
                background: 'DDD',
                color: '6d6d6d'
            },
            'CCCCCC': {
                background: 'e5e5e5',
                color: 'ccc'
            },
            'D1DADE': {
                background: 'd1dade',
                color: '5E5E5E'
            },
            'F7D1D0': {
                background: 'F7D1D0',
                color: 'c52622'
            },
            'DCEBD8': {
                background: 'DCEBD8',
                color: '5c964d'
            },
            'E1D8ED': {
                background: 'E1D8ED',
                color: '6c489c'
            },
            'D1F3EC': {
                background: 'D1F3EC',
                color: '2fb599'
            }
        },
        Cache: {},

        // Last Region content view
        mainController: {},
        lastView: {},
        page_data_change: false, // при переходе на другую страницу, смотрим были ли изменения

        ajax_time_cache: 60, // время для кеширования fetch запросов

        update_interval: 30 * 1000 * 20, // время оновления уведомлений
        //phone_mask_config: MaskOptions, // маска для телефонов в инпуте

        //Filter: FilterApi,

        Models: {},
        Vents: {},
        Temp: {},

        // leadFieldChanged: {},
        Collections: {
            Colorpicker: [] // массив коллекций у которых в модели нано изменить цвет
        },
        States: {
            isChatOpen: false,
            enabledAllSites: false,
            allSites: false
        },
        Events: {},
        Views: {},
        Layouts: {},
        Utils: {
            moment,
            ModalsFactory,
        },
        Sidebars: {}, // Для сайдбаров (звонилка, чат и тд)
        Rivets: rivets,

        loaded: false, // для анимации

        // инстанс компонента datatable
        datatable: {
            selected: 0,
            count: 10,
            el: {}, // объект плагина
            columns: {}, // колонки таблицы
            fields: {} // поля таблицы
        },

        Card: {},
        Chat: {},

        Projects: {}, // Список проектов (Backbone Collection) !!! удалить и перенести все на app.Collections.Projects

        Timezone: {},
        weekData: {},
        AUTH_ID: 0,

        Filters: [], // массив значений фильра для передачи на сервер

        //SessionData: new SessionData(),

        statisticSource: '',

        returnFromDetailedView: false,
        returnFromDetailedViewForSidebar: false,

        innerSidebarCurrentTab: void 0,

        notifyStack: {},
        notifyIndex: 0,
        notify_interval: 1000 * 60, // время обновления попап - уведомлений
        phone_mask_config: MaskOptions, // маска для телефонов в инпуте
        Filter: FilterApi,
        alert: Alert, //
        message: new Message(),
        TopNotice: new TopNotice,
        SessionData: new SessionData(),

        loadingFiles: [],

        errors: [],
        running: false,

        initialize: function() {
            $.cookie("userInNewPartner", '', { expires: -1, path: '/', domain: '.my.lptracker.ru' });
            _.extend(this.Vents, Backbone.Events);
            this.regionModal = new Modal({container: '#b-modal'});
            this._checkGetParams();
            this.isMobile = DetectMobile();
            this.storage = new Storage();

            $(window).resize(this._checkResizeOrientation.bind(this));
            this._checkResizeOrientation();
        },

        _isVerticalMobile: function () {
            var screenAngle = 0,
                screen,
                orientation;

            if(window.orientation != null) {
                screenAngle = window.orientation;
            } else if ( (screen = window.screen) != null && (orientation = screen.orientation) != null ) {
                screenAngle = orientation.angle ? orientation.angle : 0;
            }

            return (this.isMobile && (screenAngle == 90 || screenAngle == -90) ) ? true : false;
        },

        _checkResizeOrientation: function () {
            if (this.isMobile) {
                if(this._isVerticalMobile()){
                    $('body').addClass('lock-landscape');
                    $('html, body').css({minHeight: '100%'});
                }else {
                    $('html, body').css({minHeight: window.innerHeight});
                    $('body').removeClass('lock-landscape');
                }
            }
        },

        _initData: function(response) {
            app.Models.User = new User();
            app.Models.UserAccess = new UserAccess();
            app.Models.WebsocketConnectionProperties = new WebsocketConnectionPropertiesModel();
            app.Models.UserSettings = new UserSettings();
            app.Models.SiteSettings = new SiteSettings();
            app.Models.LeftMenuCount = new Backbone.Model();
            app.Models.Counters = new Backbone.Model();
            app.Models.Account = new Account();
            app.Collections.PhoneRegionsTariffs = new (Backbone.Collection.extend({
                url: AppConfig.host + '/rest/phones/regions_tariffs',
                parse: function (response) {
                    if (response.result !== undefined) {
                        return response.result.data;
                    } else {
                        return response;
                    }
                },
            }))();
            app.Timezone = new Timezone();
            app.Collections.Traffic = new Traffic();
            app.Collections.Projects = new Projects();
            app.Models.curProject = new Project();
            app.Utils.Listener = new Listener({});
            app.isMobile = DetectMobile();
            app.Collections.Menu = new Backbone.Collection();

            app.currentProjectId = sessionStorage.getItem('projectId') || app.Models.UserAccess.get('site_id')
            if (app.currentProjectId) {
                try {
                    sessionStorage.setItem('projectId', app.currentProjectId)
                } catch (e) {
                }
            }

            return response;
        },

        _checkGetParams: function() {
            var urlParam = function ( name ) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                if (results == null) {
                    return null;
                }
                else {
                    return decodeURI(results[1]) || 0;
                }
            };
            var url = window.location.href;
            var projectId = urlParam('project');
            var fromAdmin = urlParam('login_from_admin');
            var addTariff = !!urlParam('add-tariff');

            this.States.loginFromAdmin = fromAdmin;
            this.States.addTariff = addTariff;

            if (fromAdmin) {
                try {
                    sessionStorage.removeItem('projectId');
                } catch (e) {}
            }

            if (projectId) {
                try {
                    sessionStorage.setItem('projectId', projectId);
                } catch (e) {}
            }

            window.history.replaceState({},
                document.title,
                url.replace(/[\?]projectId=\d+/, '')
            );
        },

        onStart: function() {
            var detect_browser = DetectBrowser();

            if (detect_browser.old) {
                location.href = 'https://lptracker.ru/old_browser.html';
            } else {
                app.appInit();
            }

        },

        checkAccess: function (page) {
            var forbidden;

            switch (page) {
                case I18n.menu.import:
                    forbidden = app.Models.UserAccess.get('import_leads') === false;
                    break;
                case I18n.menu.import_deals:
                    forbidden = app.Models.UserAccess.get('import_deals') === false;
                    break;
                case I18n.menu.export:
                    forbidden = app.Models.UserAccess.get('export_leads') === false;
                    break;
                case I18n.menu.export_deals:
                    forbidden = app.Models.UserAccess.get('export_deals') === false;
                    break;
                case 'balance':
                    forbidden = app.Models.User.get('balance') === false;
                    break;
                case 'partners':
                    forbidden = app.Models.User.get('profile_type') != 0 && !app.Models.User.get('referral_access');
                    break;
                case 'sites':
                    forbidden = app.Models.User.get('profile_type') != 0 && app.Models.User.get('site_constructor') === false;
                    break;
                case 'code':
                    forbidden = app.Models.User.get('profile_type') != 0;
                    break;
                case 'chat':
                    forbidden = app.Models.Account.get('telephony_version') != 2 && app.AUTH_ID !== 27668 && app.AUTH_ID !== 9 && app.AUTH_ID !== 22993 && app.AUTH_ID !== 28541;
                    break;
                case 'services':
                    forbidden = app.AUTH_ID != 9;
                    break;
                case 'leads_buying':
                    forbidden = !app.Models.Account.get('big_data_enabled');
                    break;
                case 'worklog':
                    forbidden = app.Models.User.get('profile_type') != 0 && !app.Models.User.get('worklog_view_allow');
                    break;
                case 'settings':
                    forbidden = app.Models.User.get('profile_type') != 0 && app.Models.User.get('settings_access') === false;
                    break;
                default:
                    forbidden = app.Models.UserAccess.get('access_' + page) === false
            }

            return forbidden;
        },

        toHHMMSS: function (time) {
            var sec_num = parseInt(time, 10),
                hours = Math.floor(sec_num / 3600),
                minutes = Math.floor((sec_num - (hours * 3600)) / 60),
                seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            return hours + ':' + minutes + ':' + seconds;
        },

        initNotifications: function () {
            var that = this;
            var lastPage = JSON.parse($.cookie('LPT_last_page') || '{}');

            function notifyLog(text) {

            }

            function notifyMarkRead(id) {
                Backbone.ajax({
                    type: 'POST',
                    url: AppConfig.host + '/rest/system/notifications/read',
                    data: {
                        notify_id: id
                    }
                });
            }

            function getCurrentPermission() {
                if (Notification.permission) {
                    notifyLog(Notification.permission);
                } else {
                    notifyLog("не удалось получить статус разрешения");
                    notifyLog("Notifications.permission не определен (hello, google chrome)");
                }
            }

            if (lastPage.url && !window.location.hash && lastPage.url != window.location.hash) {
                window.location.hash = lastPage.url;
                return;
            }

            if (window.Notification) {
                getCurrentPermission();
            }

            if (window.disableStatusRefreshQueries) {
                return;
            }

            var notificationFunc = function () {
                Backbone.ajax({
                    url: AppConfig.host + '/rest/system/notifications',
                    success: function (response) {
                        if (response.status == 1) {
                            var data = response.result.data;
                            if (!app.intro && data.length && data.length > 0) {
                                _.each(data, function (item) {
                                    switch (item.type) {
                                        case 'basic':
                                            if (item.style == 'error') {
                                                that.message.error(item.body);
                                            } else {
                                                that.message.success(item.body);
                                            }
                                            break;
                                        case 'task':
                                            if (typeof that.notifyStack['task_' + item.task_id] == 'undefined') {
                                                that.notifyStack['task_' + item.task_id] = Messenger().post({
                                                    // showCloseButton: false,
                                                    message: item.body,
                                                    hideAfter: false
                                                });
                                            }
                                            break;
                                        default:
                                            if (Notification) {
                                                Notification.requestPermission().then(function (permission) {
                                                    if (permission === 'denied' || permission === 'default') {
                                                        if (item.style == 'error') {
                                                            that.message.error(item.body);
                                                        } else {
                                                            that.message.success(item.body);
                                                        }
                                                    }
                                                });
                                            }

                                            var theme = item.theme;
                                            var params = {
                                                body: item.body,
                                                tag: item.tag,
                                                icon: item.icon,
                                                data: {
                                                    id: item.id
                                                }
                                            };

                                            that.notifyStack["notification" + that.notifyIndex] = (params) ? new Notification(theme, params) : new Notification(theme);
                                            that.notifyStack["notification" + that.notifyIndex].onshow = function (event) {
                                                notifyLog(theme + " onshow");
                                                notifyMarkRead(event.target.data.id);

                                            };
                                            that.notifyStack["notification" + that.notifyIndex].onclick = function () {
                                                notifyLog(theme + " onclick");
                                            };
                                            that.notifyStack["notification" + that.notifyIndex].onclose = function () {
                                                notifyLog(theme + " onclose");
                                            };
                                            that.notifyStack["notification" + that.notifyIndex].onerror = function () {
                                                notifyLog(theme + " onerror");
                                            };
                                            that.notifyIndex++;
                                            break;
                                    }
                                });
                            }
                        }
                    }
                });
            };


            setTimeout(function() {
                notificationFunc();
                setInterval(notificationFunc, that.notify_interval);
            }, 10000);
        },

        initFileLoadListen: function () {
            this.Vents.on('app:startFileUpload', this.onStartFileUpload, this);
            this.Vents.on('app:stopFileUpload', this.onStopFileUpload, this);
        },

        onStartFileUpload: function (file) {
            var firstFile = !this.loadingFiles.length;
            var elementsList = 'a[href], .js-change-template, #js-header-project-name-region, #b-header .js-popover, .js-region-tasks-alerts';
            var notListenTo = '#layout-condensed-toggle, a[href*="javascript"], .certain_days_nav a';

            this.loadingFiles.push(file);
            if (firstFile) {
                $('.js-back').off('click').on('click', this.confirmWhenLoad);
                $(elementsList).not(notListenTo).off('click', this.confirmWhenLoad);
                $(elementsList).not(notListenTo).on('click', this.confirmWhenLoad);
            }
        },

        onStopFileUpload: function (file) {
            var that = this;
            var elementsList = 'a[href], .js-change-template, #js-header-project-name-region, #b-header .js-popover, .js-region-tasks-alerts';
            var notListenTo = '#layout-condensed-toggle, a[href*="javascript"], .certain_days_nav a';

            _.each(this.loadingFiles.concat(), function (loadingFile, index) {
                if (loadingFile == file) {
                    that.loadingFiles.splice(index, 1);
                }
            });

            if (!this.loadingFiles.length) {
                $('.js-back').off('click', this.confirmWhenLoad);
                $(elementsList).not(notListenTo).off('click', this.confirmWhenLoad);
            }
        },

        confirmWhenLoad: function (e) {
            var elementsList = 'a[href], .js-change-template, #js-header-project-name-region, #b-header .js-popover, .js-region-tasks-alerts';
            var notListenTo = '#layout-condensed-toggle, a[href*="javascript"], .certain_days_nav a';
            var target = $(e.target);
            var href = $.trim(target.attr('href'));
            e.preventDefault();
            e.stopPropagation();

            var confirmation = confirm(I18n.basic.confirm_exit + '\n' + 'Если вы покинете страницу до окончания загрузки файла, то файл не будет сохранен!');
            if (confirmation) {
                this.loadingFiles = [];
                $('.js-back').off('click', this.confirmWhenLoad);
                $(elementsList).not(notListenTo).off('click', this.confirmWhenLoad);
                target.trigger('click');
                if (href && href.length > 2) {
                    location.href = href;
                }
            }
        },

        checkRedirect: function () {
            Backbone.ajax({
                type: 'GET',
                url: AppConfig.host + '/rest/system/redirect?url=' + encodeURIComponent(window.location),
                success: function (response) {
                    //if (response.url) {
                    //    window.location = response.url;
                    //}
                }
            });
        },

        preload: function () {
            var that = this;

            if(app.storage.read('document_title')) {
                document.title = app.storage.read('document_title');
            }

            if(app.storage.read('document_favicon')) {
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = app.storage.read('document_favicon');
            }

            // this.getTariff()
            //     .then(function() {

                    // Tracking pixel отключен
                    // if($.cookie('user_id')) {
                    //     let authImg = new Image();
                    //     authImg.src = `https://lptracker.net.ru/admin/test.php?type=login&auth_token=${$.cookie('bearer_token')}&user_type=${$.cookie('user_type')}&user_id=${$.cookie('user_id')}`;
                    // }

                    that._initData();
                    that.loadDataFromServer()
                        .then(that.parseProfileData)
                        .then(that.initRouter)
                        .then(that.initSideCard)
                        .then(that.initResendConfirmationEmail)
                        .then(that.initOmnidesk)
                        .then(that.checkAutofunnelRequests)
                        .then(that.getNeedRedirectToCode)
                        .then(that.checkTickets)
                //     }
                // );


            app.weekData = new Backbone.Model([{
                id: 1,
                name: I18n.staff.ed.pn
            }, {
                id: 2,
                name: I18n.staff.ed.vt
            }, {
                id: 3,
                name: I18n.staff.ed.sr
            }, {
                id: 4,
                name: I18n.staff.ed.ct
            }, {
                id: 5,
                name: I18n.staff.ed.pt
            }, {
                id: 6,
                name: I18n.staff.ed.sb
            }, {
                id: 7,
                name: I18n.staff.ed.vs
            }]);
        },

        checkTickets: function() {
            let check = function(){
                Backbone.ajax({
                    type: 'GET',
                    url: AppConfig.host + '/rest/system/omnidesk/tickets?check_new',
                    success: function (response) {
                        if(response.has_new) {
                            app.message.confirm(response.message, function() {
                                window.location.href = '/#tickets';
                            }.bind(this), undefined, {id: 'tickets', queue: 'tickets', okText: 'Открыть тикеты', hideCancel: true, hideAfter: false});
                        }
                    }
                });
            }

            setInterval(check, 60000);
            check();
        },
        loadDataFromServer: function () {
            var def = new $.Deferred();
            var savedCurrentUserId = sessionStorage.getItem('userId');
            var savedResponseRaw = app.storage.read('lptStoredPreload');
            var savedResponse = savedResponseRaw && JSON.parse(savedResponseRaw);
            var resolved = false;

            if (savedResponse && savedCurrentUserId && savedResponse.result.profile.id == savedCurrentUserId && savedResponse.result.account.tariff_id && savedResponse.result.profile.phone_confirmed) {
                def.resolve(savedResponse);
                resolved = true;
            }
            app.___alerts = new $.Deferred()

            Backbone.ajax({
                type: 'GET',
                url: AppConfig.host + '/rest/system/preload?v=2',
                success: function (response) {
                    if (response.status == 1) {
                        var data = response.result;
                        delete response['status'];
                        delete response['_server_'];

                        if (data.account.tariff_id && data.profile.phone_confirmed) {
                            var dataToSave = JSON.parse(JSON.stringify(response));

                            dataToSave.result.alerts = {danger: [], warning: [], info: [], success: []};
                            dataToSave.result.account.autofunnel_requests = [];
                            dataToSave.result.call_notifications = [];
                            app.storage.write('lptStoredPreload', JSON.stringify(dataToSave));
                        }
                        if (!resolved) {
                            def.resolve(response);
                        } else {
                            app.parseProfileData(response);
                            app.checkAutofunnelRequests();
                        };
                        app.showAlerts(data.alerts);
                        app.___alerts.resolve(data.alerts)
                    }
                }
            });

            return def;
        },
        __innerFunds: (alerts) => {
          const tariffPackage = app.Models.Account.get('tariff_package');
          const isCritical = alerts && alerts.danger && alerts.danger.includes('tariff_package');

          // Если пакет активен и осталось >= 2 дней — не беспокоить (кроме критичных алертов)
          if (tariffPackage && tariffPackage.is_active && tariffPackage.days_left >= 2 && !isCritical) {
            return;
          }

          // Не более одного показа в день для некритичных случаев
          const todayStr = new Date().toISOString().slice(0, 10);
          if (!isCritical && localStorage.getItem('renewal_modal_shown_date') === todayStr) {
            return;
          }

            if(
                localStorage.getItem('force_show_renewal_modal') == 1 && window.location.hash.indexOf('#tariffs') >= 0
                ||
              (
                (!app.Models.Account.isTariffSelected() && app.Models.Account.get('tariff_id') != 11186)

                ||

                (app.Models.Account.isTariffSelected()
                  && tariffPackage
                  && tariffPackage.days_left < 2)

                ||

                isCritical
              )
              && location.hash.indexOf('#tariffs') === -1
              && app.Models.User.get('product')
              && app.Models.User.get('product').options['force_tariff_select']
            ) {
                if(app.Models.Account.get('tariff_id') == 11186) {
                    //sum = sum || 931;
                    /*$.arcticmodal('close');
                    return ModalsFactory.create('add_funds', function(AddFundsModal) {
                        app.regionHeader.currentView.triggerMethod('showModal', new AddFundsModal({
                                modalData: {
                                    paySumm: 931
                                }
                            }));
                        });
                        */
                } else {
                    if (window.location.hash.indexOf('#tariffs') >= 0) {
                      localStorage.setItem('force_show_renewal_modal', 0)
                    }
                    localStorage.setItem('renewal_modal_shown_date', todayStr);
                    return ModalsFactory.create('renewal', function (RenewalModal) {
                        app.regionHeader.currentView.triggerMethod('showModal', new RenewalModal({
                        modalData: isCritical ?
                            {'caption':"Аккаунт заблокирован! \n Для продолжения работы активируйте пакет абонентской платы"}
                            :
                            {}
                        }))});
                }
            }
        },

        // getTariff: function() {
        //     app.Models.Tariff = new Tariff();

        //     return app.Models.Tariff.fetch();
        // },

        getNeedRedirectToCode: function () {
            var def = $.Deferred();
            if (app.Models.User.get('profile_type') == 0) {
                Backbone.ajax({
                    url: AppConfig.host + '/rest/users/need-redirect-to-code',
                    type: 'GET',
                    success: function (resp) {
                        if (app.Models.User.get('profile_type') == 0 && resp.data && resp.data === true) {
                            app.setNeedRedirectToCode()
                                .then(function() {
                                    if(pageName != 'Settings') {
                                        Backbone.history.navigate('#settings', true);
                                    }
                                });
                        }
                        def.resolve();
                    },
                    error: function() {
                        def.resolve();
                    }
                });
            } else {
                def.resolve();
            }
            return def;
        },

        setNeedRedirectToCode: function () {
            var def = $.Deferred();
            if (app.Models.User.get('profile_type') == 0) {
                Backbone.ajax({
                    url: AppConfig.host + '/rest/users/has-redirect-to-code',
                    type: 'POST',
                    success: function (resp) {
                        def.resolve();
                    }
                });
            } else {
                def.resolve();
            }
            return def;
        },

        initOmnidesk: function () {
            const product = app.Models.User.get('product');

            if (app.Models.Account.get('use_omnidesk_chat')) {
                if (product && product.options['custom_omnidesk_code'] && product.options['custom_omnidesk_code'] !== '') {
                    console.log('custom omnidesk chat');
                    try {
                        console.log(eval(product.options['custom_omnidesk_code']))
                    } catch (e) {
                        console.log('custom omnidesk chat error', e);
                    }
                } else {
                    console.log('omnidesk chat');
                    !function (e, o) { !window.omni ? window.omni = [] : ''; window.omni.push(o); o.g_config = { widget_id: "13731-met0c8cp" }; o.email_widget = o.email_widget || {}; var w = o.email_widget; w.readyQueue = []; o.config = function (e) { this.g_config.user = e }; w.ready = function (e) { this.readyQueue.push(e) }; var r = e.getElementsByTagName("script")[0]; let c = e.createElement("script"); c.type = "text/javascript", c.async = !0; c.src = "https://omnidesk.ru/bundles/acmesite/js/cwidget0.2.min.js"; r.parentNode.insertBefore(c, r) }(document, []);
                }

                window.ChatraSetup = {
                    /* current user’s generated string */
                    clientId: app.Models.Account.get('chat_id')
                };

                var acc_name = '';
                var acc_type = app.Models.User.get('profile_type');
                if (acc_type == 0) {
                    acc_name = app.Models.User.get('id') + '_0';
                } else {
                    acc_name = app.Models.User.get('eid') + '_1';
                }

                window.ChatraIntegration = {
                    /* main properties */
                    name: app.Models.User.get('name'),
                    email: acc_name + '@lptracker.ru',
                    'ID_АККАУНТА': acc_type == 0 ? app.Models.User.get('id') : app.Models.User.get('user_id'),
                    'ID_СОТРУДНИКА': acc_type == 0 ? app.Models.User.get('id') : app.Models.User.get('eid'),
                    'Продукт': product ? product.name : 'LPTracker',
                };
            }
        },

        addVisor: function() {
            if (app.AUTH_ID == 36153) {
                setTimeout(function() {
                    (function(h,o,t,j,a,r){
                        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                        h._hjSettings={hjid:1982862,hjsv:6};
                        a=o.getElementsByTagName('head')[0];
                        r=o.createElement('script');r.async=1;
                        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                        a.appendChild(r);
                    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                }, 7000)
            }
        },

        parseProfileData(response) {
            var data = response.result;
            var detect_browser = DetectBrowser();

            if (typeof data.ref_balance !== 'undefined') {
                app.ref_balance = data.ref_balance;
            }

            app.storage.write('menuList', JSON.stringify(data.menu_list));
            app.storage.write('wsToken', data.ws_token);
            try {
                if (!sessionStorage.getItem('projectId')) {
                    sessionStorage.setItem('projectId', data.access.site_id);
                }
                sessionStorage.setItem('userId', data.profile.id);
            } catch(e) {}
            app.AUTH_ID = data.auth_id;
            if (!app.currentProjectId) {
                app.currentProjectId = data.access.site_id;
            }
            app.isSupport = data.is_support;
            app.isAdmin = data.is_admin;

            app.menu = data.menu_list;
            app.Models.User.set(data.profile);
            app.Models.UserAccess.set(data.access);
            app.SessionData.set(data.session_data);
            app.SessionData.set(data.session_data);
            app.next_page = data.next_page;
            app.support_work = data.support_work;
            app.support_callback_phone = data.support_callback_phone;
            app.support_telegram_username = data.support_telegram_username || '';
            app.support_whatsapp_phone = data.support_whatsapp_phone || '';
            app.can_support_callback = data.can_support_callback;
            app.can_support_callback_help = data.can_support_callback_help;

            app.Models.WebsocketConnectionProperties.set(data.chat);
            app.Models.UserSettings.set(data.user_settings);
            app.Models.SiteSettings.set(data.site_settings);
            app.Models.LeftMenuCount.set(data.counters);
            app.Models.Counters.set(data.counters);
            app.Models.Account.set(data.account);
            app.Collections.PhoneRegionsTariffs.set(data.phone_regions_tariffs);
            app.Timezone.set(data.timezone_list);
            app.Collections.Projects.set(data.projects || []);
            // app.Models.curProject = app.Collections.Projects.get(app.currentProjectId);
            app.Models.curProject = new Project(data.current_project);

            // if (!app.Models.curProject) {
            //     app.Models.curProject = app.Collections.Projects.models[0]
            app.currentProjectId = app.Models.curProject && app.Models.curProject.id
            // }
            if (app.currentProjectId) {
                try {
                    sessionStorage.setItem('projectId', app.currentProjectId)
                    app.Views.Header.render();
                } catch (e) {
                }
            }

            if (!_.isUndefined(data.account.tariff_id) && detect_browser.old ) {
                location.href = 'https://lptracker.ru/old_browser.html';
            }

            if (typeof data.traffic != 'undefined') {
                app.Collections.Traffic.set(data.traffic);
            }

            app.curProject = app.Models.curProject.toJSON();

            if (typeof data.intercom !== 'undefined') {
                app.Models.Intercom = new Backbone.Model(data.intercom)
            }

            if (typeof app.Models.User !== 'undefined') {
                var acc_name = '';
                var acc_type = app.Models.User.get('profile_type');
                if (acc_type == 0) {
                    acc_name = app.Models.User.get('id');
                } else {
                    acc_name = app.Models.User.get('user_id') + '_' + app.Models.User.get('eid');
                }
                $('.logo').attr('title', acc_name).attr('data-placement', 'bottom');
            }
            if (!app.Models.Account.get('user_registered_identification') && app.Models.Account.get('balance') < 0) {
                var event = $.Event();
                event.currentTarget = $({}).data({
                    modal: 'add_funds',
                    paySumm: app.Models.Account.get('payment_month')
                });
                app.Vents.trigger('modal:showModal', event);
            }

            if (data.call_notifications && data.call_notifications.length) {
                _.forEach(data.call_notifications, function(notification) {
                    app.onSocketRedirectMsg(notification);
                })
            }

            app.setProductData();
        },

        setProductData() {
            const product = app.Models.User.get('product');
            const btnColor = product && product.options['button-color'];
            const btnTextColor = product && product.options['button-text-color'];
            const productName = product && product.name;

            if (btnColor) {
                document.body.style.setProperty('--main-btn-color', btnColor);
                document.body.style.setProperty('--main-btn-hover-color', btnColor);
                document.body.style.setProperty('--main-btn-active-color', btnColor);
                document.body.style.setProperty('--main-btn-active-border', btnColor);
            }

            if (btnTextColor) {
                document.body.style.setProperty('--main-btn-text-color', btnTextColor);
            }

            app.storage.write('btnColor', btnColor || '#0aa699');
            app.storage.write('btnTextColor', btnTextColor || '#ffffff');
            app.storage.write('productName', productName || 'LPTracker');
        },

        initRouter: function () {
            app.initNotifyConnection();
            // app.initLPTRackerIsOnline();
            app.mainController = new Desktop();
            app = app || {};

            app.Router = new Routes({
                controller: app.mainController
            });
            Backbone.history.start();

            app.listenTo(app.Collections.Projects, 'change', function () {
                app.alert.hideWarning();

                Backbone.ajax({
                    url: AppConfig.host + '/rest/users/account-status',
                    type: 'GET'
                }).then(function(res) {
                    app.showAlerts(res.result.alerts)
                })
            });

            app.running = true;
        },

        initSideCard: function() {
            var sideCard = new SideCard();
        },

        showConfirmPhoneModal: function(phone) {
            var def = new $.Deferred();

            ModalsFactory.create('confirmPhone', function(Modal) {
                var modal = new Modal({
                    modalData: {
                        phone: phone
                    }
                });
                this.listenTo(modal, 'code:send', function(request_id, phone) {
                    def.resolve(request_id, phone);
                }.bind(this));
                app.regionModal.show(modal);
            }.bind(this));

            return def;
        },

        showConfirmCodePhoneModal: function(request_id) {
            var def = new $.Deferred();

            ModalsFactory.create('codeConfirmPhone', function(Modal) {
                var modal = new Modal({
                    modalData: {
                        request_id: request_id
                    }
                });
                this.listenTo(modal, 'phone:confirmed', function(request_id) {
                    def.resolve();
                }.bind(this));
                this.listenTo(modal, 'phone:change', function() {
                    def.reject();
                }.bind(this));
                app.regionModal.show(modal);
            }.bind(this));

            return def;
        },

        showAccountDetail: function() {
            ModalsFactory.create('new_user_login', function (NewUserInfo) {
                var newUserInfo = new NewUserInfo();

                newUserInfo.on('saved', function () {
                    app.Models.User.set('show_details_modal', false);
                });
                app.regionModal.show(newUserInfo);
            }.bind(this));
        },

        showMobileVersion: function() {
            const product = app.Models.User.get('product');
            if (app.isMobile && (!product || product.domain == 'my.lptracker.ru')) {
                ModalsFactory.create('mobileVersion', function(Modal) {
                    var modal = new Modal();
                    app.regionModal.show(modal);
                }.bind(this));
            }
        },

        redirectToPollIfNeed: function () {
          const product = app.Models.User.get('product');
          const redirectToPoll = product && product.options.offer_product_selection;

          if (redirectToPoll) {
            Backbone.history.navigate('#poll', true);
          } else {
            this.redirectAfterRegister();
          }
          app.Models.User.set('phone_confirmed', true);
        },
        checkNewUser: function (phone) {
            var newUserInfo;

            if (app.Models.User.get('profile_type') == 0 && !app.Models.User.get('phone_confirmed') && app.Models.Account.get('tariff_id') && !app.States.loginFromAdmin) {
                this.showConfirmPhoneModal(phone)
                    .then(function(request_id, phoneSended) {
                        this.showMobileVersion();
                        if(request_id > 0) {
                          this.showConfirmCodePhoneModal(request_id)
                            .then(function() {
                              this.redirectToPollIfNeed();
                            }.bind(this))
                            .fail(function() {
                              this.checkNewUser(phoneSended);
                            }.bind(this));
                        } else {
                          this.redirectToPollIfNeed();
                        }
                    }.bind(this));
            } else {
                this.showMobileVersion();
            }
        },

        redirectAfterRegister: function(functions) {
            const product = app.Models.User.get('product');
            if(functions && functions.length) {
                let params = Object.entries(functions).map(([key, val]) => `functions[]=${val}`).join('&');

                window.location.href = `https://my.lptracker.ru/land/tutorial.php?domain=${window.location.host}&${params}`
                return;
            }

            const redirectUrl = product && product.register_redirect_url || 'https://my.lptracker.ru';

            window.location.href = redirectUrl;
            $('body div.page-content').css('margin-left', '');
            $('#main-menu').css('display', '');
            $('#b-header').css('display', '');
        },

        initResendConfirmationEmail: function () {
            if (!app.Models.User.get('email_confirmed')) {
                $(document.body).on('click', '#resend-confirmation-email', function (event) {
                    event.preventDefault();
                    Backbone.ajax({
                        type: 'POST',
                        url: AppConfig.host + '/rest/system/resend_confirmation_email',
                        contentType: 'application/json',
                        success: function (result) {
                            app.message.success('Повторное письмо отправлено Вам на почту ' + result.email);
                        }
                    });
                });
            }
        },

        showAlerts: function (data) {
            var alertIndex = 0;
            var alert = {};
            // var dateTill = app.Models.Tariff.get('active_till');
            // var now = Date.now();
            var alertOptions;
            var alerts;
            var type;
            var alertTextData = {};

            // var modules = app.Models.Tariff.get('modules');
            // var sms = modules.find({name: 'sms'});
            // var smsActiveTill = sms.get('active_till');
            // var hasSms = sms.get('balance') > 0 && smsActiveTill && now < smsActiveTill*1000;

            if (typeof data !== "object") {
                return;
            }

            if (!app.Models.Account.get('tariff_id')) {
                if (location.hash.indexOf('#tariffs') != 0) {
                    data = {
                        danger: _.filter(data.danger || [], function (item) {
                            return item == 'activation'
                        })
                    }
                } else {
                    return
                }
            }

            if (data['danger'] && data['danger'].length) {
                type = 'danger';
                alerts = data['danger'];

                // if ((alerts[0] == 'tariff' || (alerts[0] == 'balance' && !app.Models.Account.get('user_registered_identification'))) && dateTill && (dateTill * 1000 < now) && !app.States.loginFromAdmin || app.curPage && app.curPage.pageName == 'Partners') {
                //     $('body').addClass('blockedView').css('overflow', 'scroll');
                //     $('body div.page-content').css('margin-left', '0px');
                //     $('#main-menu').css('display', 'none');
                //     $('#b-header').css('display', 'none');
                //     $('#b-content').css('padding-top', '26px');
                //     $('.b-alert-background').hide();
                // }
            } else if (data['warning'] && data['warning'].length) {
                type = 'warning';
                alerts = data['warning'];
            }

            //for (var type in alerts) {
                // Пропускаем постоянно скрытые (localStorage) алерты про баны/модерацию —
                // чтобы под скрытым верхним не потерять следующий по приоритету (напр. баланс).
                if (alerts && alerts.length) {
                    alerts = _.filter(alerts, function (a) {
                        return !(app.alert && app.alert.isPersistDismissed && app.alert.isPersistDismissed(a));
                    });
                }
                if (alerts && alerts.length) {
                    alerts.sort(
                        function (a, b) {
                            return I18n.system_alerts[type][b].priority - I18n.system_alerts[type][a].priority;
                        });
                    var show_current = true;

                    alert = _.extend({}, I18n.system_alerts[type][alerts[0]]);
                    if (alert.getTextData) {
                        alertTextData = alert.getTextData();
                    }
                    alert.text = Marionette.Renderer.render(alert.text, alertTextData);

                    if (alerts[0]=='balance' || alerts[0]=='tariff_package') {
                        if (app.Models.Account.get('user_registered_identification')) {
                            alert.options.buttons.splice(1,2);
                            type = 'warning';
                        }

                        const product = app.Models.User.get('product');
                        const showTopupBalanceBtn = product && product.options.topup_balance;
                        const paymentUrl = product && product.options.payment_url;

                        if(paymentUrl) {
                            alert.options.buttons[0].data = {};
                            alert.options.buttons[0].href = paymentUrl;
                            alert.options.buttons[0].target = '_blank';
                        } else {
                            if (!showTopupBalanceBtn) {
                                delete alert.options.buttons;
                            } else {
                              if(!app.Models.Account.isTariffSelected()) {
                                  alert.options.buttons[0].data.modal = 'selectTariff';
                              }
                            }
                        }
                    }

                    if (alert.options) {
                        if (alert.options.buttons) {
                            $(alert.options.buttons).each(function (bi, be) {
                                if (be.newPartnerExpression) {
                                    if (be.newPartnerExpression == 1) {
                                        if (app.Models && app.Models.Account && app.Models.Account.get('new_partner') == 1) {
                                            be.href = '/partner/new_account.php';
                                        }
                                    }
                                }
                            });
                        }
                    }

                    // Умная плашка верификации: если активный алерт связан с mtt_verification
                    // и бэк прислал verify-состояние — берём текст и кнопки из общей матрицы
                    // (та же, что в окне покупки номеров), показываем только недостающее.
                    var MTT_VERIFY_KEYS = ['not_verified', 'mtt_person_incomplete', 'mtt_org_incomplete',
                        'mtt_ip_incomplete', 'mtt_rejected', 'mtt_revoked', 'mtt_review_pending',
                        'mtt_moderation'];
                    if (data.mtt_verify && _.contains(MTT_VERIFY_KEYS, alerts[0])) {
                        var vc = MttVerify.getContent(data.mtt_verify);
                        alert.text = '<b>' + vc.title + '</b><br>' + vc.body;
                        alert.options = _.extend({}, alert.options, {
                            buttons: _.map(vc.buttons, function (b) {
                                var st = { color: '#5e5e5e', backgroundColor: '#ffffff', border: '1px solid #e5e9ec' };
                                // b.dismiss → «Больше не показывать» (постоянное скрытие, localStorage);
                                // b.modal → кнопка открывает модал через alert.showModal;
                                // b.href → обычная ссылка.
                                if (b.dismiss) {
                                    return { text: b.text, href: 'javascript:void(0)', className: 'js-alert-dismiss-forever', style: st };
                                }
                                if (b.modal) {
                                    return { text: b.text, data: { modal: b.modal }, style: st };
                                }
                                return { text: b.text, href: b.href, target: '_blank', style: st };
                            })
                        });
                    }

                    alertOptions = _.extend({alertId: alerts[0]}, alert.options);

                    if (typeof alertOptions.id !== 'undefined') {
                        var exist_alert = $('.' + alertOptions.id);
                        if (typeof exist_alert.length !== 'undefined' && exist_alert.length == 1) {
                            show_current = false;
                        }
                    }
                    if (show_current) {
                        if (alertIndex === 0) {
                            app.alert[type](alert.text, alert.duration, alertOptions);
                        } else {
                            app.alert.queue(alert.text, alert.duration, alertOptions);
                        }
                    }

                    if (data['danger'] && data['danger'].length) {
                        if ((alerts[0] == 'tariff' || (alerts[0] == 'balance' && !app.Models.Account.get('user_registered_identification'))) && !app.States.loginFromAdmin || app.curPage && (app.curPage.pageName == 'Partners' || app.curPage.pageName == 'Tickets')) {
                            $('body').addClass('blockedView').css('overflow', 'scroll');
                            $('body div.page-content').css('margin-left', '0px');
                            $('#main-menu').css('display', 'none');
                            $('#b-header').css('display', 'none');
                            // $('#b-content').css('padding-top', '26px');
                            $('.b-alert-background').hide();
                        }
                    }
                }
            //}
        },

        // checkProjects: function () {
        //     if (!app.Collections.Projects.length) {
        //         ModalsFactory.create('no_projects', function(NoProjects) {
        //             app.regionModal.show(new NoProjects({
        //                 preventOverlayClick: true
        //             }));
        //         })
        //     }
        // },

        checkAutofunnelRequests: function() {
            var requests = app.Models.Account.get('autofunnel_requests') || [];

            _.each(requests, function(request) {
                app.message.confirm('Запрос на копирование автоворонки "' + request.name + '"',
                    function() {
                        const approve = () => {
                            Backbone.ajax({
                                url: AppConfig.host + '/rest/autofunnel/requests/' + request.id + '/approve',
                                type: 'POST'
                            })
                            .fail((xhr) => {
                                if (xhr.status == 409) {
                                    app.message.confirm(xhr.responseJSON.message ? `${xhr.responseJSON.message}. Перейти на следущий тариф?` : 'Достигнут лимит для Вашего тарифа. Перейти на следущий тариф?', () => {
                                        const currentPackage = app.Models.Account.get('tariff_package') || {};
                                        if (currentPackage.is_active) {
                                            Backbone.ajax({
                                                url: AppConfig.host + '/rest/tariffs/raise-tariff-dryrun',
                                                type: 'POST',
                                                data: JSON.stringify({
                                                    type: 'voice_chat_bots'
                                                }),
                                                dataType: 'JSON',
                                                success: function (response) {
                                                    app.message.confirm(`У вас есть активный тарифный пакет, срок действия будет обновлен до <strong>${response.date}</strong> после изменения тарифа.<br/>Вы уверены, что хотите активировать новый тариф?`,
                                                        function () {
                                                            Backbone.ajax({
                                                                    url: AppConfig.host + '/rest/tariffs/raise-tariff',
                                                                    type: 'POST',
                                                                    data: JSON.stringify({
                                                                        type: 'voice_chat_bots'
                                                                    })
                                                                })
                                                                .then(() => {
                                                                    approve();
                                                                })
                                                                .fail(xhr => {
                                                                    app.message.error(xhr.responseJSON.message || 'Ошибка');
                                                                })
                                                        },
                                                        function () {
                                                        },
                                                        {
                                                            okText: 'Ок',
                                                            cancelText: 'Отмена'
                                                        }
                                                    )
                                                },
                                                error: function (response) {
                                                    app.message.error(response.responseJSON.message);
                                                }
                                            });
                                        } else {
                                            Backbone.ajax({
                                                    url: AppConfig.host + '/rest/tariffs/raise-tariff',
                                                    type: 'POST',
                                                    data: JSON.stringify({
                                                        type: 'voice_chat_bots'
                                                    })
                                                })
                                                .then(() => {
                                                    approve();
                                                })
                                                .fail(xhr => {
                                                    app.message.error(xhr.responseJSON.message || 'Ошибка');
                                                })
                                        }
                                    })
                                }
                            });
                        }
                        approve();
                    },
                    function() {
                        Backbone.ajax({
                            url: AppConfig.host + '/rest/autofunnel/requests/' + request.id + '/deny',
                            type: 'POST'
                        })
                    },
                    {
                        okText: 'Подтвердить',
                        cancelText: 'Отмена',
                        hideAfter: false
                    }
                )
            })
        },

        resizeWindow: function () {
            app.Vents.trigger('app:windowResize')
        },

        confirm_modal: function (options) {
            var that = this;
            var modalOptions = {};

            if (options.success !== undefined) {
                modalOptions.callback_success = options.success;
                delete options.success;
            }

            if (options.error !== undefined) {
                modalOptions.callback_error = options.error;
                delete options.error;
            }

            modalOptions = _.extend(modalOptions, options);
            ModalsFactory.create('confirm_modal', function(ConfirmModal) {
                app.regionModal.show(new ConfirmModal(modalOptions), options.id);
            })
        },

        confirmModal: function (options) {
          return new Promise((resolve, reject) => {
            options.success = resolve;
            options.error = reject;
            this.confirm_modal(options);
          });
        },

        confirm_delete: function (options) {
            var that = this;
            var modalOptions = {};

            if (options.success !== undefined) {
                modalOptions.callback_success = options.success;
                delete options.success;
            }

            if (options.error !== undefined) {
                modalOptions.callback_error = options.error;
                delete options.error;
            }

            modalOptions = _.extend(modalOptions, options);
            ModalsFactory.create('confirm_delete', function(ConfirmDelete) {
                app.regionModal.show(new ConfirmDelete(modalOptions));
            });
        },

        reloadContent: function (notReload) {
            app.mainController.reloadRegionContent(notReload);
        },

        initLPTRackerIsOnline: function () {
            window.LPTRACKET_IS_ONLINE = true;
            window.LPTRACKET_IS_ONLINE_OLD = true;

            $(document).ready(function () {
                window.LPTRACKER_ONLINE_CONFIG = {
                    image_url: 'https://lptracker.ru/img/vk_catcher.png'
                };
                var LPTRACKER_CHECK_INTERNET_CONNECTION = function () {
                    if (typeof navigator === "object" && typeof navigator.onLine === "boolean") {
                        window.LPTRACKET_IS_ONLINE = navigator.onLine;
                    } else {
                        //hack for older bizzare browsers
                        var i = new Image();
                        i.onerror = function () {
                            window.LPTRACKET_IS_ONLINE = false
                        };
                        i.onload = function () {
                            window.LPTRACKET_IS_ONLINE = true
                        };
                        i.src = window.LPTRACKER_ONLINE_CONFIG.image_url + new Date().getTime();
                    }
                    if (window.LPTRACKET_IS_ONLINE_OLD != window.LPTRACKET_IS_ONLINE) {
                        if (window.LPTRACKET_IS_ONLINE) {
                            if (window.LPTRACKET_IS_ONLINE_MESSAGE) {
                                window.LPTRACKET_IS_ONLINE_MESSAGE.cancel();
                            }
                            app.message.success('Соединение с сервером восстановлено');
                            !app.running && app.start();
                        } else {
                            window.LPTRACKET_IS_ONLINE_MESSAGE = app.message.error('Потеряно соединение с сервером. Изменения не будут сохранены!', false);
                        }
                        window.LPTRACKET_IS_ONLINE_OLD = window.LPTRACKET_IS_ONLINE;
                    }
                };
                setInterval(LPTRACKER_CHECK_INTERNET_CONNECTION, 3000);
                LPTRACKER_CHECK_INTERNET_CONNECTION();
            });
        },

        getUrlParameterByName: function (name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        checkCallTime: function(method, value, callback)
        {
            Backbone.ajax({
                type: 'GET',
                url: AppConfig.host + '/rest/contacts/check_call_time?project_id='+app.currentProjectId+'&'+method+'='+value,
                success: function (response) {
                    if(response.status == 1){
                        callback();
                    }else{
                        app.message.confirm(response.message,
                            function() {
                                callback();
                            },
                            function() {
                            },
                            {
                                okText: 'Да',
                                cancelText: 'Нет'
                            }
                        )
                    }
                }
            });
        },

        pingWebSocket: function() {
            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/system/websocket',
                contentType: 'application/json',
                data: JSON.stringify({
                    msg: 'ping'
                })
            });
        },

        initNotifyConnection: function () {
            var that = this;
            var connection = ConnectionFactory.createNotifyConnection();
            var modal;
            var status;
            var progressStatus = {
                error: {
                    template: 'Произошла ошибка при {operation}!',
                    format: function (operation) {
                        return this.template
                            .replace('{operation}', operation || 'фоновой операции');
                    }
                },
                ok: {
                    template: '{operation} завершен{suffix}!',
                    format: function (operation, suffix) {
                        return this.template
                            .replace('{operation}', operation || 'Фоновая операция')
                            .replace('{suffix}', suffix || 'а');
                    }
                },
                progress: {
                    template: 'Производится {operation} в проекте {projectId}<br>' +
                    'Прогресс: {percent}%<br>' +
                    'После завершения процесса данные могут обновляться еще в течение 15 минут',
                    format: function (operation, percent, projectId) {
                        return this.template
                            .replace('{operation}', operation || 'фоновая операция')
                            .replace('{projectId}', projectId)
                            .replace('{percent}', percent);
                    }
                }
            };

            setTimeout(function() {
                Backbone.ajax({
                    type: 'GET',
                    url: AppConfig.host + '/rest/leads/import/status',
                    success: function (response) {
                        if (response.active && response.userId == app.Models.User.id) {
                            app.message.success("Импортирование " + response.progress + "%"+"<br />После завершения процесса данные могут обновляться еще в течение 15 минут", false, false, {id: response._server_.request_id});
                        }
                    }
                });
                Backbone.ajax({
                    type: 'GET',
                    url: AppConfig.host + '/rest/system/notifications',
                    success: function (response) {
                        _.each(response, function(notify) {
                            notify.event = 'notification_message';
                            connection._fireMessageReceived({data:JSON.stringify({message:notify})});
                        })
                    }
                });
            }, 7000);

            connection.on('connect', () => {
                app.pingWebSocket();
            })

            connection.on('message:received', function (data) {
                switch (data.event) {
                    case 'userecho_comment_created': {
                        app.message.success('В Вашем вопросе появился <a href="'+data.comment_url+'" style="color:#ccc;" rel="noopener" target="_blank">комментарий</a>');
                        break;
                    }
                    case 'redirect':
                        that.onSocketRedirectMsg(data);
                        break;
                    case 'redirect_canceled':
                        var clid = data.clid || '';
                        var contactId = data.contact_id || '';
                        var redirectKey = (contactId + clid) || 'unknown';

                        app.message.hide(redirectKey);
                        break;
                    case 'account':
                        for (var property in data.data) {
                            app.Models.Account.set(property, data.data[property]);
                        }
                        // if (data.tariff) {
                        //     app.Models.Tariff.get('modules').reset(data.tariff.modules);
                        //     data.tariff.modules = app.Models.Tariff.get('modules');
                        //     app.Models.Tariff.set(data.tariff);
                        // }
                        break;
                    case 'balance':
                        app.Models.Account.set('balance', data.balance);
                        break;
                    case 'new_leads':
                        app.Models.LeftMenuCount.set('leads_new', data.count);
                        break;
                    case 'new_deals':
                        app.Models.LeftMenuCount.set('deals_new', data.count);
                        break;
                    case 'due_tasks':
                        app.Models.Counters.set('due_tasks', data.count);
                        break;
                    case 'missed_calls':
                        app.Models.Counters.set('missed_calls', data.count);
                        break;
                    case 'unseen_chats':
                        const projectChatsCounts = data.projects || [];
                        const currentProjectChatsCount = projectChatsCounts.find(projectCount => app.curProject.id == projectCount.id) || {};

                        app.Models.Counters.set('unseen_chats', currentProjectChatsCount.count || 0);
                        break;
                    case 'notification_message':
                        if (data.type === 'hide') {
                            app.message.hide(data.messageId);
                        } else if (window.outerWidth > 700 && data.body.indexOf('#tasks/task/') == -1) {
                            if (data.type === 'success') {
                                app.message.success(data.body, undefined, true, {id: data.messageId, queue: data.queue || 'notifications'});
                            } else if (data.type === 'error') {
                                app.message.error(data.body, undefined, {id: data.messageId, queue: data.queue || 'notifications'});
                            }
                        }
                        break;
                    case 'phones_bought':
                        // Номер купили в фоне: без этого список остаётся тем, каким
                        // его отдал сервер в момент постановки покупки в очередь
                        if (app.Collections && app.Collections.Phones) {
                            app.Collections.Phones.fetch();
                        }
                        break;
                    case 'contact_progress':
                        var progressName = {
                            error: {
                                delete: 'удалении контактов'
                            },
                            ok: {
                                delete: 'Удаление контактов'
                            },
                            progress: {
                                delete: 'удаление контактов'
                            }
                        };
                        if (data.status === -1) {
                            app.message.hide(data.origin);
                            app.message.error(progressStatus.error.format(progressName.error[data.origin]));
                            app.Vents.trigger('app:unBlockUi');
                        } else if (data.status === 1) {
                            app.message.hide(data.origin);
                            app.message.success(progressStatus.ok.format(progressName.ok[data.origin], 'о'));
                            app.Vents.trigger('app:unBlockUi');
                        } else {
                            app.message.success(progressStatus.progress.format(progressName.progress[data.origin], data.percent, app.Models.curProject.id), false, undefined, {id: data.origin});
                        }
                        break;
                    case 'user_status':
                        status = data.status == 1;
                        app.Models.User.set({
                            allow_calls: status,
                            work_status: status
                        });
                        app.Vents.trigger('user:statusChange', status);
                        break;
                    case 'notification_status':
                        var notificationKey = data.origin + '_' + data.queue;
                        var notificationStatus = 'Отправлено уведомление.',
                            notificationsSent = false;

                        if (!Messenger().findById(notificationKey + '_op').length) {
                            app.message.success('Операция выполняется', false, undefined, {
                                id: notificationKey + '_op',
                                actions: {
                                    retry: {
                                        label: 'Остановить',
                                        action: function () {
                                            app.message.confirm('Остановить отправку сообщений?',
                                                function () {
                                                    Backbone.ajax({
                                                        url: AppConfig.host + '/rest/system/batches/messages/' + data.queue.replace('batch:', ''),
                                                        type: 'DELETE'
                                                    })
                                                },
                                                function () {
                                                },
                                                {
                                                    okText: 'Да',
                                                    cancelText: 'Нет'
                                                }
                                            )
                                        }
                                    }
                                }
                            });
                        }

                        if (typeof data.ready !== 'undefined') {
                            notificationStatus = 'Подготовлено сообщений к отправке: ' + data.ready + ' из ' + data.total + '.';
                        } else if (typeof data.address !== 'undefined') {
                            switch (data.type) {
                                case 0:
                                    notificationStatus = 'Отправлено письмо на e-mail ' + data.address + '.';
                                    notificationsSent = true;
                                    break;
                                case 1:
                                    notificationStatus = 'Отправлено sms на номер ' + data.address + '.';
                                    notificationsSent = true;
                                    break;
                            }
                        } else {
                            switch (data.type) {
                                case 0:
                                    if (data.sent + data.failed === data.total) {
                                        notificationStatus = 'Отправлено ' + data.sent + ' писем, не удалось отправить: ' + data.failed + '.';
                                        notificationsSent = true;
                                    } else {
                                        notificationStatus = 'Отправлено писем: ' + data.sent + ' из ' + data.total + ', не удалось отправить: ' + data.failed + '.';
                                    }
                                    break;
                                case 1:
                                    if (data.sent + data.failed === data.total) {
                                        notificationStatus = 'Отправлено ' + data.sent + ' sms сообщений, не удалось отправить: ' + data.failed + '.';
                                        notificationsSent = true;
                                    } else {
                                        notificationStatus = 'Отправлено sms сообщений: ' + data.sent + ' из ' + data.total + ', не удалось отправить: ' + data.failed + '.';
                                    }
                                    break;
                            }
                        }

                        if (data.canceled || data.sent + data.failed === data.total) {
                            app.message.hide(notificationKey + '_op');
                        }

                        if (notificationsSent) {
                            app.message.custom(notificationStatus, undefined, undefined, {id: notificationKey});
                            app.message.hide(notificationKey + '_op');
                        } else {
                            app.message.success(notificationStatus, false, undefined, {id: notificationKey});
                        }
                        break;
                    case 'mail_domain':
                        if (data.active) {
                            app.message.success('Производится создание домена ' + (data.name || ''), false, undefined, {id: 'createDomainMsg'});
                        } else {
                            app.message.hide('createDomainMsg');
                            if (data.message) {
                                app.message.error('Невозможно создать домен ' + (data.name || '') + ': ' + (data.message || 'неизвестная ошибка'));
                            } else {
                                app.message.success('Создание домена ' + (data.name || '') + ' завершено');
                            }
                        }
                        break;
                    case 'partner_offer':
                        if (data.offer_id && data.partner_id) {
                            app.message.confirm('Вам доступен новый лид для партнерки. Лиды предоставляются для обработки по телефону. Если Вы не сможете конвертировать лиды в оплаты, то следующие лиды Вам предоставляться не будут',
                                function() {
                                    Backbone.ajax({
                                        url: AppConfig.host + '/rest/partners/accept_offer',
                                        type: 'POST',
                                        contentType: 'application/json',
                                        data: JSON.stringify({
                                            offer_id: data.offer_id
                                        }),
                                        success: function(response) {
                                            if (response.status = 1) {
                                                var msg = app.message.error('Партнер был успешно привязан.<br/>Можете скачать скрипт и позвонить партнеру прямо сейчас<br/><div class="messenger-actions"><span data-action="retry"><span class="messenger-phrase"></span><a class="js-call-partner">Позвонить</a></span><span data-action="cancel"><span class="messenger-phrase"></span><a href="http://lptracker.io/checklist.pdf" target="_blank">Скачать скрипт</a></span></div>', false);
                                                msg.$el.find('.js-call-partner').one('click', function() {
                                                    app.checkCallTime('phone', response.result.data.user_phone, function(){
                                                        Backbone.ajax({
                                                            url: AppConfig.host + '/rest/contacts/call_to_number',
                                                            type: 'POST',
                                                            contentType: 'application/json',
                                                            data: JSON.stringify({
                                                                phone: response.result.data.user_phone
                                                            })
                                                        });
                                                    });
                                                });
                                                msg.$el.find('a').one('click', function() {
                                                    msg.cancel();
                                                })
                                            }
                                        }
                                    })
                                },
                                function() {
                                    Backbone.ajax({
                                        url: AppConfig.host + '/rest/partners/decline_offer',
                                        type: 'POST',
                                        contentType: 'application/json',
                                        data: JSON.stringify({
                                            offer_id: data.offer_id
                                        })
                                    })
                                },
                                {
                                    id: data.offer_id,
                                    okText: 'Забрать лид',
                                    cancelText: 'Отказаться от лида'
                                }
                            )
                        }
                        break;
                    case 'partner_offer_cancelled':
                        if (data.offer_id && data.partner_id) {
                            app.message.hide(data.offer_id);
                        }
                        break;

                    case 'calltracking_add_phone':
                        if(app.Models.UserAccess.get('access_calltracking') && app.Models.UserAccess.get('access_virtual_pbx') && data.sipnumber) {
                            app.message.success('Мы спасли Ваш лид от попадания в неопознанный трафик!<br/>Для этого мы подключили Вам дополнительный онлайн номер<br/>' + data.sipnumber);
                        }
                        break;
                    case 'logout':
                        Backbone.history.navigate('#logout', true);
                        break;
                    case 'relog':
                        if (app.isAdmin) {
                            sessionStorage.removeItem('projectId');
                            if(window.location.hash != '#logout') {
                                window.location.reload();
                            }
                        }
                        break;
                    case 'SiteCopyProgress':
                        switch (+data.body.status) {
                            case 1:
                                app.message.success('Проект скопирован');
                                break;
                            case 2:
                                app.message.success('При копировании проекта возникла ошибка');
                                break;
                        }
                        break;
                    case 'SiteCopyRequest':
                        const resolveRequest = (solution) => {
                            Backbone.ajax({
                                url: AppConfig.host + `/rest/sites/${data.body.project_id || 0}/copy/${data.body.id}/resolve`,
                                type: 'POST',
                                contentType: 'application/json',
                                data: JSON.stringify({
                                    solution,
                                }),
                                error(xhr) {
                                    let message = xhr.responseJSON && xhr.responseJSON.message || 'При копировании проекта возникла ошибка';

                                    switch (+xhr.status) {
                                        case 404:
                                            message = 'Заявка на копирование проекта не найдена';
                                            break;
                                        case 409:
                                            message = 'Подтверждение невозможно';
                                            break;
                                    }
                                    app.message.error(message);
                                }
                            });
                        }
                        switch (data.type) {
                            case 'new':
                                if (data.body.account_id == app.AUTH_ID && data.body.is_need_up_tariff) {
                                    app.message.confirm('Достигнут лимит проектов для Вашего тарифа. Перейти на следущий тариф?',
                                        () => {
                                            resolveRequest(2)
                                        }
                                    )
                                } else {
                                    app.message.confirm(`Запрос на копирование проекта<br/>${data.body.project_name}`,
                                        function () {
                                            if (data.body.is_need_up_tariff) {
                                                app.message.confirm('Достигнут лимит проектов для Вашего тарифа. Перейти на следущий тариф?',
                                                    () => {
                                                        resolveRequest(2)
                                                    }
                                                )
                                            } else {
                                                resolveRequest(2);
                                            }
                                        },
                                        function () {
                                            resolveRequest(3);
                                        },
                                        {
                                            id: data.offer_id,
                                            okText: 'Подтвердить',
                                            cancelText: 'Отмена'
                                        }
                                    )
                                }
                                break;
                            case 'resolved':
                                app.message.hide(data.id);
                                break;
                        }
                        break;
                }

                switch (data.command) {
                    case 'update_leads':
                        app.Vents.trigger('leads:updateData', data.id);
                        break;
                    case 'update_contacts':
                        app.Vents.trigger('pagination:refresh');
                        app.Vents.trigger('userFilters:load');
                        app.Vents.trigger('sidebar:refreshCounts');
                        break;
                }

                switch (data.source) {
                    case 'chat':
                        if (data.totalUnseen != undefined) {
                            app.Models.Counters.set('#chat', data.totalUnseen);
                        }
                        break;
                }
            });
            require(['./modules/leads/events'], function(LeadsEvents) {
                new LeadsEvents({connection: connection});
            });
            require(['./modules/tasks/events'], function(TaskEvents) {
                new TaskEvents({connection: connection});
            });

            app.connection = connection;
        },

        onSocketRedirectMsg: function(data) {
            var clid = data.clid || '';
            var contactId = data.contact_id || '';
            var redirectKey = (contactId + clid) || 'unknown';
            var types = {
                callback: 'Звонок с виджета',
                form_callback: 'Звонок по захвату формы',
                usercatch_callback: 'Звонок по захвату посетителя',
                dial: 'Исходящий звонок',
                auto_action: 'Автодействие',
                autodial: 'Автодозвон',
                ticket: 'Напоминание о задаче',
                autofunnel: 'Автоворонка'
            };
            var type = types[data.callback_type] || '';
            var delCallNotification = function() {
                Backbone.ajax({
                    type: 'DELETE',
                    url: AppConfig.host + '/rest/system/call-notification/' + data.contact_id
                })
            };

            // Сервер повторяет redirect каждые 3 с, пока не получит подтверждение, звонок не закончится или не пройдёт 10 минут
            if (clid && data.hasOwnProperty('contact_id')) {
                Backbone.ajax({
                    type: 'POST',
                    url: AppConfig.host + '/rest/system/call-notification/' + data.contact_id + '/ack?clid=' + encodeURIComponent(clid)
                });
            }
            var canShow = window.outerWidth > 700 && data.hasOwnProperty('contact_id') && data.show_card && data.callback_type !== 'from_agent' && data.owner_you == true;
            // Окно этого звонка уже на экране — повтор не перерисовываем: hide удалил бы запись окна на сервере
            if (canShow && app.message.isShown(redirectKey)) {
                return;
            }

            app.message.hide(redirectKey);
            if (canShow) {
                let msg = app.message.confirm((data.funnel_stage || '') + '<br/>' + (type ? type + '<br/>' : '') + (data.client_name ? data.client_name + ' ' : '') + '<b>' + (app.Models.User.get('show_lptracker_number') ? '' : data.contact_phone || '') + '</b> ',
                    function() {
                        var fragment = Backbone.history.getFragment();

                        if (!data.lead_id) {
                            var url = '?project=' + data.project_id + '#contacts/card/' + data.contact_id;
                            var contactTab = window.open(url);
                            contactTab.opener = null;
                        } else {
                            if (fragment.indexOf('leads/card') >=0 || fragment.indexOf('deals/card') >=0) {
                                var leadUrl = data.lead_id ? '?project=' + data.project_id + '#leads/card/' + data.lead_id : '?project=' + data.project_id + '#contacts/card/' + data.contact_id;
                                var leadTab = window.open(leadUrl);
                                leadTab.opener = null;
                            } else {

                                if(data.project_id == app.curProject.id) {
                                    require(['pages/leads/card'], function (Card) {
                                            var leadCard = new Card({
                                                id: data.lead_id,
                                                isSideCard: true,
                                            });
                                            app.Vents.trigger('sideCard:show', leadCard, {hideClose: false});
                                    })
                                } else {
                                    window.location.href = '#leads/card/' + data.lead_id
                                }
                            }
                        }
                        delCallNotification();
                    }, function() {
                        var url = '?project=' + data.project_id + '#contacts/card/' + data.contact_id;
                        var contactTab = window.open(url);
                        contactTab.opener = null;
                        delCallNotification();
                    }, {
                        id: redirectKey,
                        okText: 'Открыть',
                        cancelText: 'В новом окне',
                        hideAfter: false
                })
                this.listenTo(msg, 'hide', () => delCallNotification());
            }
        },

        declOfNum: function (number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];
            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },

        selectProject: function (id, notReload) {
            var accessUrl = AppConfig.host + '/rest/employees/access/';
            if (app.Models.User.get('profile_type') === 0) {
                accessUrl = AppConfig.host + '/rest/users/access/';
            }

            app.currentProjectId = id;
            try {
                sessionStorage.setItem('projectId', id);
            } catch (e) {}
            app.Models.LeftMenuCount.set(
                {
                    leads_new: 0,
                    deals_new: 0
                },
                {silent: true}
            );
            // $.when(
                // Backbone.ajax({
                //     type: 'GET',
                //     url: AppConfig.host + '/rest/system/cntrs-info',
                //     success: function (response) {
                //         if (response.status == 1) {
                //             app.Models.Counters.set(response.result);
                //         }
                //     }
                // }),
                Backbone.ajax({
                    url: accessUrl + app.Models.User.get('id') + '/' + app.currentProjectId
                }).then(function(response) {
                    app.Models.UserAccess.set(response.result.data[0]);
                })
            // )
                .then((function() {
                app.message.success('Проект изменен');

                app.Models.curProject = app.Collections.Projects.get(id);
                app.curProject = app.Collections.Projects.get(id).toJSON();
                app.pingWebSocket();
                app.Views.Header.render();
                app.Vents.trigger('app:changeProject', id, notReload);

                if (!notReload) {
                    if (app.curPage && app.curPage.pageName == 'LeadsCard') {
                        window.location.href = '/#leads';
                    } else if (!notReload && app.curPage && app.curPage.pageName == 'ContactsCard') {
                        window.location.href = '/#contacts';
                    } else {
                        // app.reloadContent(notReload);
                        Backbone.history.loadUrl(`${Backbone.history.fragment.split('?')[0]}?reload`);
                    }
                }


                var FunnelSteps = require('collections/crater_steps');
                app.Collections.CraterSteps = new FunnelSteps();
                app.Collections.CraterSteps.fetch({
                    cache: true,
                    expires: app.ajax_time_cache,
                    data: {
                        private: true
                    }
                });
                this.listenTo(app.Collections.CraterSteps, 'sync', app.curPage.afterSync());
            }).bind(this))
        },
    //});


        appInit: function() {
            this.checkRedirect();
            this.preload();
            this.resizeWindow();
            this.initFileLoadListen();
            $(window).on("resize", app.resizeWindow);

            // this.listenTo(this.Vents, 'reset:changedLeadFields', this.resetLeadFieldChanged);

            this.listenTo(this.Vents, 'app:blockUi', function () {
                $('.b-uiblock-overlay').show();
            });

            this.listenTo(this.Vents, 'app:unBlockUi', function () {
                $('.b-uiblock-overlay').hide();
            });

            this.listenTo(this.Vents, 'app:selectProject', this.selectProject);

            this.listenTo(this.Vents, 'app:changeProject', function () {
                app.alert.hideWarning();
                Backbone.ajax({
                    url: AppConfig.host + '/rest/users/account-status',
                    type: 'GET'
                }).then(function(res) {
                    app.showAlerts(res.result.alerts)
                })
            });

            top.addEventListener('message', function(event) {
                if (typeof event.data == 'object' && event.data.type == 'showModal') {
                    ModalsFactory.create(event.data.modal, function (Modal) {
                        app.regionModal.show(new Modal({
                            modalData: event.data.data
                        }));
                    });
                }
            });
        }
    });

    app.regionSidebar.on('show', function (view, region, options) {
        $('.scrollbar-macosx').scrollbar();
    });

    app.regionContent.on('show', function (view, region, options) {
        $('.select2').select2({
            language: {
                noResults: function () {
                    return 'Ничего не найдено'
                }
            }
        });

        $("#multi").select2({
            placeholder: "Ответственный",
            width: '100%',
            language: {
                noResults: function () {
                    return 'Ничего не найдено'
                }
            }
        });

        //$('*[title]').tooltip();
        $(document).on('click', '*[title]', function (e) {
            if(!app.intro) {
                $(this).tooltip('hide');
            }
        });

        // Clockpicker
        $('.clockpicker').clockpicker({
            placement: 'bottom',
            align: 'left',
            autoclose: true,
            'default': 'now'
        });

        // Tabs
        $('.nav.nav-tabs a').on('click', function (event) {
            event.preventDefault();
            $(this).tab('show');
        });
        $('.nav.nav-pills a').on('click', function (event) {
            event.preventDefault();
            $(this).tab('show');
        });

        // Scrollbar
        $('.scrollbar-macosx').scrollbar();
        $('.scrollbar-inner').scrollbar();

        view.on('render', function () {
            // Tooltips
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            });

            // Clockpicker
            $('.clockpicker').clockpicker({
                placement: 'bottom',
                align: 'left',
                autoclose: true,
                'default': 'now'
            });

            // Tabs
            view.$('.nav.nav-tabs a').on('click', function (event) {
                event.preventDefault();
                $(this).tab('show');
            });
            view.$('.nav.nav-pills a').on('click', function (event) {
                event.preventDefault();
                $(this).tab('show');
            });

        });
    });


    function checkPendingRequest() {
        //if ($.active > 0) {
        //    $('#logo_header_loader').addClass('visible');
        //} else {
        //    $('#logo_header_loader').removeClass('visible');
        //}
    }

    window.setInterval(checkPendingRequest, 500);

    Marionette.Behaviors.behaviorsLookup = function () {
        return window.Behaviors;
    };

    Marionette.Renderer.render = function (template, data) {
        var toHTML = Handlebars.compile(template);
        return toHTML(data);
    };

    app.regionSidebar.on('show', function (view, region, options) {
        $('.scrollbar-macosx').scrollbar();
    });

    window.addEventListener('error', function ErrHandler(event) {
        var message = 'message: ' + event. message + ';\n ' + 'filename: ' + event.filename + ';\n ' + 'lineno: ' + event.lineno + ';\n ' + 'colno: ' + event.colno + ';\n ' + (event.error ? 'stack:\n ' + event.error.stack : '');
        var url = document.location.href;
        var hostname = document.location.hostname;
        var hash = document.location.hash;
        var scriptUrl = event.filename;
        var ua = navigator.userAgent;

        Backbone.ajax({
            type: 'POST',
            url: AppConfig.host + AppConfig.loggerUrl,
            contentType: 'application/json',
            data: JSON.stringify({
                message: message,
                url: url,
                hostname: hostname,
                hash: hash,
                scriptUrl: scriptUrl,
                ua: ua,
            })
        });
    })

    $(window).on('hashchange', function () {
        $('.tooltip').remove();
    });

    window.addEventListener('storage', function(event) {
        if (event.key == 'authToken' && event.oldValue != event.newValue) {
            if (!event.newValue) {
                location.href = '/login'
            } else {
                location.reload()
            }
        }
    });

    window.app = app || false;
    app.start();

    return app;
});
